import { cn } from "../lib/cn";

export interface CopyButtonProps {
  copied: boolean;
  onClick: () => void;
  fontSize?: number;
  className?: string;
}

export function CopyButton({
  copied,
  onClick,
  fontSize = 9,
  className,
}: CopyButtonProps) {
  const iconSize = fontSize + 2;
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "cursor-pointer border-none bg-transparent transition-colors duration-200",
        copied ? "text-gold" : "text-text-muted hover:text-text",
        className,
      )}
      style={{ fontSize }}
      aria-label={copied ? "Copied" : "Copy"}
    >
      {copied ? (
        "\u2713"
      ) : (
        <svg
          width={iconSize}
          height={iconSize}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      )}
    </button>
  );
}
